<div class="flex-container">
  <h3 *ngIf="!!errorMessage.msgTitle" class="font-san-serif-md" [innerHTML]="errorMessage.msgTitle" id="err-msg-heading"></h3>
  <div *ngIf="!!errorMessage.msgBody" class="err-body" [innerHTML]="errorMessage.msgBody" id="err-msg-body"></div>
  <div [class]="errorMessage.msgImgUrl"></div>
</div>
